export default __webpack_public_path__ + "static/home-recipe-example-3-c8eb58b5d3d79a1764d081c299059372.jpg";